import { Play, Apple, Info } from 'lucide-react';
import { SectionLabel, Reveal } from '../Section';

export default function DownloadCTA({ settings }) {
  const android = settings?.android_download_url;
  const ios = settings?.ios_download_url;
  const version = settings?.app_version;
  const size = settings?.app_size;

  return (
    <section id="download" className="py-20 sm:py-28 relative overflow-hidden" data-testid="download-section">
      <div className="absolute inset-0 red-radial" aria-hidden="true" />
      <div className="relative max-w-7xl mx-auto px-5 sm:px-8 text-center flex flex-col items-center">
        <SectionLabel testid="download-label">Download</SectionLabel>
        <Reveal>
          <h2 className="mt-5 font-display text-white text-4xl sm:text-6xl">
            Download <span className="text-[#e8173a]">KROY Esports</span>
          </h2>
        </Reveal>
        <Reveal delay={0.1}>
          <p className="mt-4 text-[#9e9e9e] text-sm sm:text-base max-w-md">
            Your next tournament is one tap away. Free to download, free to start.
          </p>
        </Reveal>
        {(android || ios) && (
          <Reveal delay={0.15} className="w-full max-w-xl">
            <div className="mt-10 flex flex-col sm:flex-row gap-4">
              {android && (
                <a
                  data-testid="download-google-play-button"
                  href={android}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex-1 inline-flex items-center justify-center gap-3 bg-[#e8173a] hover:bg-[#c0102e] text-white font-extrabold uppercase tracking-wider text-sm px-8 py-4 rounded-xl transition-all duration-300 hover:shadow-[0_20px_50px_-15px_rgba(232,23,58,0.7)] hover:-translate-y-0.5 active:scale-95"
                >
                  <Play className="w-5 h-5 fill-current" />
                  Google Play
                </a>
              )}
              {ios && (
                <a
                  data-testid="download-app-store-button"
                  href={ios}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex-1 inline-flex items-center justify-center gap-3 bg-transparent border-2 border-[#e8173a] text-[#e8173a] hover:bg-[#e8173a]/10 font-extrabold uppercase tracking-wider text-sm px-8 py-4 rounded-xl transition-all duration-300 hover:-translate-y-0.5 active:scale-95"
                >
                  <Apple className="w-5 h-5 fill-current" />
                  App Store
                </a>
              )}
            </div>
          </Reveal>
        )}
        {(version || size) && (
          <Reveal delay={0.2}>
            <p className="mt-6 inline-flex items-center gap-2 text-xs text-[#8a8a8a] font-medium" data-testid="download-version-info">
              <Info className="w-3.5 h-3.5 text-[#e8173a]" />
              {version && <span>Version {version}</span>}
              {version && size && <span className="text-[#3a3a3a]">•</span>}
              {size && <span>{size}</span>}
            </p>
          </Reveal>
        )}
      </div>
    </section>
  );
}
